import { atom } from "recoil";

const notificationStateAtom = atom({
    key: 'notificationState',
    default: false
})

export default notificationStateAtom;